import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import { GetCorporateClientsByMarathonIdParams, GetCorporateClientsByMarathonIdRes, GetCorporateClientsByUserIdParams, GetCorporateClientsByUserIdRes, GetCorporateClientsExcelByMarathonIdParams, GetCorporateClientsLookupParams, GetCorporateClientsLookupResponse, GetCorporateClientsNamesByMarathonIdParams, GetCorporateClientsNamesByMarathonIdRes, GetCorporateClientsParams, GetCorporateClientsRes, GetCorporateClientsWithVouchersByMarathonIdParams, GetCorporateClientsWithVouchersByMarathonIdRes } from "./types";
import { List } from "../../slice/types";

export const corporateClientsAPI = {
  getIsUserResponsibleForCorporateClient: async (): Promise<boolean> => {
    const response = await axiosApi.get<boolean>(
      '/corporateclients/isUserResponsible',
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getCorporateClientsByUserId: async (params: GetCorporateClientsByUserIdParams): Promise<GetCorporateClientsByUserIdRes> => {
    const response = await axiosApi.get<GetCorporateClientsByUserIdRes>(
      `/corporateclients/GetCorporateClientsByUserId/${params.userId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getCorporateClientsExcelByMarathonId: async (params: GetCorporateClientsExcelByMarathonIdParams): Promise<void> => {
    const response = await axiosApi.get<void>(
      `/corporateclients/${params.marathonId}/excel`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getCorporateClientsNamesByMarathonId: async (params: GetCorporateClientsNamesByMarathonIdParams): Promise<GetCorporateClientsNamesByMarathonIdRes> => {
    const response = await axiosApi.get<GetCorporateClientsNamesByMarathonIdRes>(
      `/corporateclients/${params.marathonId}/names`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getCorporateClientsByMarathonId: async (params: GetCorporateClientsByMarathonIdParams): Promise<GetCorporateClientsByMarathonIdRes> => {
    const response = await axiosApi.get<GetCorporateClientsByMarathonIdRes>(
      `/corporateclients/${params.marathonId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getCorporateClientsWithVouchersByMarathonId: async (params: GetCorporateClientsWithVouchersByMarathonIdParams): Promise<GetCorporateClientsWithVouchersByMarathonIdRes> => {
    const response = await axiosApi.get<GetCorporateClientsWithVouchersByMarathonIdRes>(
      `/corporateclients/withVouchers/${params.marathonId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getCorporateClients: async (params: GetCorporateClientsParams): Promise<GetCorporateClientsRes> => {
    const response = await axiosApi.get<GetCorporateClientsRes>(
      `/corporateclients`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getCorporateClientsLookup: async (params: GetCorporateClientsLookupParams): Promise<List<GetCorporateClientsLookupResponse>> => {
    const response = await axiosApi.get<List<GetCorporateClientsLookupResponse>>(
      `/corporateclients/lookup`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
}
